import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { FantasyLeaderboardQuery, FantasyLeaderboard, FantasyLeaderboardService } from '@fgb/core';
import { Subscription, combineLatest } from 'rxjs';
import * as _moment from 'moment';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';
const moment = _moment;
@Component({
  selector: 'fgb-fantasy-leaderboard-page',
  templateUrl: './fantasy-leaderboard-page.component.html',
  styleUrls: ['./fantasy-leaderboard-page.component.scss'],
})
export class FantasyLeaderboardPageComponent implements OnInit, OnDestroy {
  @Input() backButtonLink: string = '/games/pickaplayer';

  yearlyLeaderboards: FantasyLeaderboard[];
  monthlyLeaderboard: any[] = [];
  fantasySub: Subscription;

  showMonthly: boolean = true;
  year: number = new Date().getFullYear();

  customOptions: OwlOptions = {
    items: 1,
    margin: OwlCarouselSettings.Margin,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    nav: true,
    dots: false,
    startPosition: new Date().getMonth(),
    navText: ['<i class="icon-arrow-1-left fw-bold"></i>', '<i class="icon-arrow-1-right fw-bold"></i>'],
    stagePadding: 0,
  };

  constructor(
    private fantasyLeaderboardQuery: FantasyLeaderboardQuery,
    private fantasyLeaderboardService: FantasyLeaderboardService
  ) {}

  ngOnInit() {
    this.fantasySub = combineLatest([
      this.fantasyLeaderboardService.fetchMonthlyLeaderboard(10),
      this.fantasyLeaderboardService.fetchYearlyLeaderboard(10),
    ]).subscribe((x) => {
      let monthly = this.fantasyLeaderboardQuery.getMonthlyLeaderboard() as FantasyLeaderboard[];
      this.yearlyLeaderboards = this.fantasyLeaderboardQuery.getYearlyLeaderboard();

      let today = new Date();

      for (let index = 1; index <= 12; index++) {
        this.monthlyLeaderboard.push({
          month: moment.monthsShort(index - 1) + ' ' + today.getFullYear(),
          entries: monthly.filter((x: FantasyLeaderboard) => {
            return ((x.FantasyMonth as unknown) as number) === index;
          }),
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.fantasySub) {
      this.fantasySub.unsubscribe();
    }
  }
}
